import { PublicOff } from "@mui/icons-material";
import { Box, Dialog, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledDialog = styled(Dialog)({
  "& .MuiDialog-paper": {
    maxWidth: "500px",
    padding: "2rem",
    position: "relative",
  },
});

export const IconContainer = styled(Box)({
  display: "flex",
  justifyContent: "center",
  marginBottom: "1rem",
});

export const StyledPublicOffIcon = styled(PublicOff)({
  fontSize: "4rem",
  color: "#1976d2",
  opacity: 0.8,
});

export const Title = styled(Typography)({
  textAlign: "center",
  fontSize: "1.5rem",
  fontWeight: 600,
  marginBottom: "0.75rem",
});

export const Message = styled(Typography)({
  textAlign: "center",
  color: "#666",
  marginBottom: "1.5rem",
  fontSize: "0.95rem",
  lineHeight: 1.6,
});

export const ButtonContainer = styled(Box)({
  display: "flex",
  justifyContent: "center",
});
